// import 文を使って sub.js ファイルを読み込む。
var $ = require("jquery");
import 'jquery-scrollify';
import 'jquery-inview';
import anime from 'animejs'
import 'lightbox2';
import "../js/jquery.nuts.js";
import "../js/clipboard.js";
//import 'slick-carousel';
//import Barba from "barba.js"
//import 'pretty-scroll';
//import 'imagesloaded';
require('../sass/style.scss');

/*$('html,body').animate({ scrollTop: 0 }, '1');*/

$(function () {
var $body = $('body');
$('#js__btn').on('click', function () {
$body.toggleClass('side-open');
});
$('#js__nav').on('click', function () {
$body.removeClass('side-open');
});
});


$(function() {
var $section = $('.js-section'); // 各スライド
var $pager = $('#js-pager'); // ページャー枠
// scrollifyのオプション設定
var option = {
section : '.js-section',
easing: "swing",
scrollSpeed: 600,
scrollbars: true,
updateHash:false,
before:function(index) {
//setCurrent(index); // 現在のsectionにクラスを設定
pagerCurrent(index); // ページャーに対応する順番にクラス名を付与
},
afterRender:function() {
createPager(); // ページャーの作成
//setCurrent(); // 現在のsectionにクラスを設定
}
};
$(window).on('resize',function(){
if(current){
var currentScrl = $('.js-section').eq(current).offset().top;
$(window).scrollTop(currentScrl);
}
});
	
$(function() {
$.scrollify(option); // scrollifyの実行
});

/*// 現在のsectionにクラスを設定
function setCurrent(index) {
// 一旦、すべてのsectionのクラスをとる
$section.removeClass('is-show');
// 現在のsectionのみにクラスを付与
$section.eq(index).addClass('is-show');
}*/

// ページャーに対応する順番にクラス名を付与
function pagerCurrent(index) {
var $li = $pager.find('li');
$li.removeClass('is-current');
$li.eq(index).addClass('is-current');
}

// ページャーの作成
function createPager() {
$section.each(function(i, e){
// ページ内リンク先の作成
var sectionName = $(e).attr('data-section-name');
// 最初のliにはクラスを付与
var addClass = '';
if (i === 0) {
addClass = 'is-current';
}
// liのHTML作成
var html = '';
html += '<li class="' + addClass + '">';
html += '<a href="#' + sectionName + '"></a>';
html += '</li>';
$pager.append(html);
});

pagerLink();
}

// ページャーでaタグをクリックされたらスクロールする
function pagerLink () {
$pager.find('a').on('click', function() {
$.scrollify.move($(this).attr("href"));
});
}
});

$(function() {
var lineDrawing = anime({
targets: '.lineDrawing .lines path',
strokeDashoffset: [anime.setDashoffset, 0],
easing: 'easeInOutSine',
duration: 1000,
fill: '#fff',
//delay: function(el, i) { return i * 50 },
delay: function(el, i, l) {
return 1000 + (i * 50);
},
stroke: {
value: 'rgba(255,255,255,0)',
delay: function(el, i, l) {
return 1000 + (i * 100);
},
},
offset: 0,
});
});

$(function() {
$('.ani').on('inview', function(event, isInView, visiblePartX, visiblePartY) {
$(this).stop().addClass('ani_on');
});
});

$(function() {
$('.show').on('inview', function(event, isInView, visiblePartX, visiblePartY) {
console.log(isInView);
if(isInView){
$(this).stop().addClass('is-show');
}
else{
$(this).stop().removeClass('is-show');
}
});
});

$(function() {
$('#container').cleverInfiniteScroll({
contentsWrapperSelector: '#container',
contentSelector: '.wrapper',
nextSelector: '#next',
//loadImage: 'https://djnuts.jp/wp/wp-content/themes/djnuts2018_new/img/ajax-loader.gif'
});
});

jQuery('a[href^=#]').click(function() {
var speed = 400;
var href= jQuery(this).attr("href");
var target = jQuery(href == "#" || href == "" ? 'html' : href);
var position = target.offset().top;
jQuery('body,html').animate({scrollTop:position}, speed, 'swing');
return false;
});







/*$(function() {
var winHeight = $(window).height();
var headerHeight = $('header').innerHeight();
var innerHeight = winHeight - headerHeight ;
$('.fv').css("height", innerHeight + "px");
});*/



//////////////////
// WEBPACK FOOTER
// ./src/main.js
// module id = 329
// module chunks = 0